module.exports = __webpack_public_path__ + "media/images/linkedin_black-c57c74e5.svg";